<template>
  <div justify="center">
    <v-dialog v-model="dialog" scrollable max-width="90%" persistent>
      <template v-slot:activator="{}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn class="mx-2" small icon v-on="on" @click="dialog = !dialog">
              <v-icon>mdi-chair-rolling</v-icon>
            </v-btn>
          </template>
          <span>Gestión Gerencia</span>
        </v-tooltip>
      </template>

      <v-card class="mx-auto">
        <v-toolbar color="primary" dark>Gestión Gerencia</v-toolbar>

        <v-card-text>
          <moduloG />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Cerrar
          </v-btn>
          <!--
          <v-btn color="blue darken-1" text @click="dialog = false">
            Save
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import loadCartera from "../../../components/loadFile/carteras/cartera.vue";
import moduloG from "../GestionCartera/g/gestionBasica.vue";

export default {
  name: "indicadoresCarteraGerencia",
  props: [],
  components: {
    loadCartera,
    moduloG,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {},
  computed: {
    retornaEstadoMensaje() {
      //return (this.sheet = this.estadoMensaje);
    },
  },
};
</script>